import { NgModule } from '@angular/core';
import { SalesTeamMultiSelectComponent } from './sales-team-multi-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { SalesTeamMultiSelectStoreService } from './sales-team-multi-select-store.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  MARKET_ID_TOKEN,
  PARTNER_ID_TOKEN,
  SALES_TEAM_MULTI_SELECT_CONFIG_TOKEN,
  SALES_TEAMS_SERVICE_TOKEN,
  SalesTeamMultiSelectConfig,
  SalesTeamsService,
} from './tokens';

@NgModule({
  declarations: [SalesTeamMultiSelectComponent],
  exports: [SalesTeamMultiSelectComponent],
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, TranslateModule, VaFormsModule],
  providers: [
    SalesTeamMultiSelectStoreService,
    { provide: PARTNER_ID_TOKEN, deps: [SALES_TEAM_MULTI_SELECT_CONFIG_TOKEN], useFactory: partnerIdFactory },
    { provide: MARKET_ID_TOKEN, deps: [SALES_TEAM_MULTI_SELECT_CONFIG_TOKEN], useFactory: marketIdFactory },
    {
      provide: SALES_TEAMS_SERVICE_TOKEN,
      deps: [SALES_TEAM_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: salesTeamsServiceFactory,
    },
  ],
})
export class SalesTeamMultiSelectModule {}

function partnerIdFactory(config: SalesTeamMultiSelectConfig): Observable<string> {
  return config.partnerId$;
}

function marketIdFactory(config: SalesTeamMultiSelectConfig): Observable<string> {
  return config.marketId$;
}

function salesTeamsServiceFactory(config: SalesTeamMultiSelectConfig): SalesTeamsService {
  return config.salesTeamsService;
}
